import type { LoaderFunction } from 'react-router-dom';
import { apiListArenasByPage } from "../../api/arenaApi";
import { combineAdminLoader } from "./AdminRouteProtection";

const ArenaHandlerLoaderInternal: LoaderFunction = async () => {
    try {
        const response = await apiListArenasByPage(1);
        // La risposta ha struttura: { data: [...], current_page: ... }
        return response.data || response;
    } catch (error) {
        throw new Error('Failed to load arenas');
    }
};

// Wrapper con protezione admin
export const ArenaHandlerLoader: LoaderFunction = combineAdminLoader(ArenaHandlerLoaderInternal);
